<p class="modal-title">Requirements</p>
<p class="modal-description">
  In order to claim your payload of 0.05 coins you will need to fulfill the
  requirements below:
</p>

<div class="requirements-list flex flex-col gap-4">
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [checked]="requirements().balance"
    >
      <p class="requirement-description flex items-center gap-4">
        Have
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/core/price.svg"
        />
        0 in your
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/core/skins.svg"
        ></svg-icon>
        balance (empty)
      </p></app-checkbox
    >
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().level"
      ><p class="requirement-description flex items-center gap-4">
        Level 10+ on site
      </p></app-checkbox
    >
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().discord"
    >
      <p class="requirement-description flex items-center gap-4">
        Join our
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/socials/discord.svg"
        ></svg-icon>
        <span class="highlight">Discord</span> server and
        <span
          class="highlight"
          (click)="$event.stopPropagation(); sessionService.authDiscord()"
          style="cursor: pointer"
        >
          verify
        </span>
        you joined
      </p>
    </app-checkbox>
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().name"
      ><p class="requirement-description flex items-center gap-4">
        Add
        <span class="highlight">#TF2Hunt</span> to your steam name
      </p></app-checkbox
    >
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().steamPublic"
      ><p class="requirement-description flex items-center gap-4">
        Steam Profile & Inventory must be public
      </p></app-checkbox
    >
  </div>
</div>
<div class="buttons flex items-center gap-8 w-full">
  <div
    class="pointer-events-none button button--style-white-04 h-40 rounded-4 padding-x-12 status w-full"
  >
    Status:
    <span
      [style.color]="requirements().eligible ? 'var(--green)' : 'var(--red)'"
    >
      {{ requirements().eligible ? "Eligible" : "Not Eligible" }}
    </span>
  </div>
  <button
    class="button button--style-white-04 h-40 rounded-4 padding-x-12 refresh-button w-full"
    (click)="handleRefresh()"
  >
    Refresh
  </button>
</div>
